(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[69701],{

/***/ 24979:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/blog",
      function () {
        return __webpack_require__(72850);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LIMIT": function() { return /* binding */ LIMIT; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ SeveralBrandsHome; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/severalBrandsWrapper.tsx + 9 modules
var severalBrandsWrapper = __webpack_require__(73191);
// EXTERNAL MODULE: ./src/components/severalbrands/whyPartnerWithUs/index.tsx
var whyPartnerWithUs = __webpack_require__(64080);
// EXTERNAL MODULE: ./src/components/severalbrands/blogs/firstSection/style.module.scss
var style_module = __webpack_require__(82651);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/severalbrands/sharedButton/index.tsx
var sharedButton = __webpack_require__(81467);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 111 modules
var motion = __webpack_require__(76265);
// EXTERNAL MODULE: ./src/components/shared/loader/index.tsx
var loader = __webpack_require__(95301);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 53 modules
var axios = __webpack_require__(29061);
// EXTERNAL MODULE: ./src/components/severalbrands/utils/index.ts
var utils = __webpack_require__(54531);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
;// CONCATENATED MODULE: ./src/components/severalbrands/blogs/firstSection/index.tsx











function FirstSection({ blogsArrProp , domainInfo  }) {
    const { 0: blogsArr , 1: setBlogsArr  } = (0,react.useState)(blogsArrProp);
    const { 0: offset , 1: setOffset  } = (0,react.useState)(LIMIT);
    const { 0: blogsArrError , 1: setBlogsArrError  } = (0,react.useState)(false);
    const { 0: blogsArrLoading , 1: setBlogsArrLoading  } = (0,react.useState)(false);
    const { 0: showButton , 1: setShowButton  } = (0,react.useState)(true);
    const showMoreClickHandler = async ()=>{
        setBlogsArrLoading(true);
        try {
            const res = await axios/* default.post */.Z.post("/api/severalBrandsGetData", {
                offset: offset,
                domainId: domainInfo.id
            });
            const newPosts = res.data.data.allPosts;
            if (newPosts) {
                setBlogsArr((prev)=>[
                        ...prev,
                        ...newPosts
                    ]);
                setOffset((prev)=>prev + LIMIT);
                setBlogsArrLoading(false);
                if (newPosts.length === 0 || newPosts.length < LIMIT) {
                    setShowButton(false);
                }
            }
        } catch (error) {
            if (error) {
                setBlogsArrLoading(false);
                setBlogsArrError(true);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.section */.E.section, {
        transition: {
            duration: 1.5
        },
        initial: {
            opacity: 0,
            y: 150
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        viewport: {
            once: true
        },
        className: "lg:mt-28 mt-14 px-4 lg:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "font-bold text-[#351C4F] 3xl:text-8xl 3xl:leading-[5.5rem] lg:text-6xl lg:leading-[4.5rem] text-3xl leading-10 text-center",
                children: "Lead Generation Insights"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "3xl:mt-7 mt-5 3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 3xl:max-w-[1053px] max-w-[910px] mx-auto text-center font-light",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "This is where we, at Several Brands, share practical strategies for performance-driven lead generation. Whether you're in legal, auto, home services, or technology, you'll find vertical-specific tactics, industry trends, and practical tips to help you attract high-intent leads and refine your sales funnel."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-3",
                        children: [
                            "For downloadable tools and frameworks, visit our",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://severalbrands.com/key-considerations",
                                className: "text-[#EF4F80] hover:underline",
                                children: "Resources"
                            }),
                            " ",
                            "page."
                        ]
                    })
                ]
            }),
            blogsArr && blogsArr.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " lg:mt-28 mt-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "font-bold text-[#351C4F] 3xl:text-7xl 3xl:leading-[4.5rem] lg:text-5xl lg:leading-[3.5rem] text-2xl leading-9 text-center",
                        children: "Browse the Latest Articles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " flex flex-wrap justify-evenly ",
                        children: blogsArr.map((blog)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.a */.E.a, {
                                initial: {
                                    opacity: 0,
                                    y: 30
                                },
                                animate: {
                                    opacity: 1,
                                    y: 0
                                },
                                className: (style_module_default()).blogEl,
                                href: `${blog.url.isMain ? blog.url.url : blog.url.main.url}`,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: `${(style_module_default()).imgContainer} relative  h-[230px] 3xl:h-[300px] w-[100%]`,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: `${blog.image ? blog.image.fullPath : "/severalbrands/assets/images/placeHolder.png"}`,
                                                    alt: "Image",
                                                    layout: "fill",
                                                    objectFit: "cover"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "font-bold 3xl:text-3xl 3xl:leading-10 lg:text-xl lg:leading-8 text-center mt-9 px-4",
                                                children: (0,sharedUtils/* replacePlaceholders */.wT)(blog.title, {
                                                    category: blog?.category?.label ?? blog?.category?.name
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "3xl:text-xl lg:text-base text-sm text-[#B0B0B0] text-center",
                                        children: [
                                            "Last Updated On :",
                                            " ",
                                            (0,utils/* getFormattedDate */.L0)(blog.updatedAt)
                                        ]
                                    })
                                ]
                            }, blog.id))
                    }),
                    showButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-fit mx-auto lg:mt-20 mt-10 ",
                        children: blogsArrLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                            size: 30,
                            className: "text-[#351C4F]"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {
                            regularButton: true,
                            onCLick: showMoreClickHandler,
                            children: "Show More"
                        })
                    }),
                    blogsArrError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "w-fit mx-auto text-xs mt-1 text-[#ff4242]",
                        children: "Something went wrong"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "w-fit mx-auto lg:mt-28 mt-14",
                children: "No Blogs to show"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/metaTags/index.tsx
var severalbrands_metaTags = __webpack_require__(66405);
;// CONCATENATED MODULE: ./pages/severalbrands/blog.tsx







const partnerWitUSDataBlogPage = {
    title: "Why Partner with Us?",
    paragraphs: [
        {
            text: `At Several Brands, you're a growth ally, not just a client; we only succeed when you do. Our vertical experts build and adjust campaigns around your KPIs, backed by lead validation that combines AI screening with human review, and flexible engagement terms rather than a rigid, one-size-fits-all contract. If a lead doesn't fit, we'll swap or credit it, no hassle.`,
            className: "default"
        },
        {
            text: `Ready to turn these strategies into pipeline growth? From lead generation to reporting, we handle the full process so your team can focus on closing.`,
            className: "mt-6  3xl:max-w-[1040px] 3xl:text-xl max-w-[740px]  font-light"
        }, 
    ],
    buttonText: "Talk to Our Sales Team"
};
var __N_SSG = true;
const LIMIT = 3;
function SeveralBrandsHome({ allPosts , domain  }) {
    const metaTags = (0,utils/* getMetaTitleDescriptionForPage */.Z5)(domain, "Blog");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(severalBrandsWrapper/* default */.Z, {
        domainInfo: domain,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(severalbrands_metaTags/* default */.Z, {
                title: metaTags?.title ?? "Blog | SeveralBrands.com",
                description: metaTags?.description ?? "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.",
                keyWords: (0,utils/* getKeyWordsForMetaTags */.U8)(domain)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstSection, {
                blogsArrProp: allPosts,
                domainInfo: domain
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-32 lg:mt-56 lg:mb-52 mb-20 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whyPartnerWithUs/* default */.Z, {
                    partnerWitUSData: partnerWitUSDataBlogPage
                })
            })
        ]
    });
}


/***/ }),

/***/ 81467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57772);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton({ children , href , pdf , regularButton =false , onCLick , scrollButton =false  }) {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    const buttonClassName = `  text-white  py-3 sm:px-16 px-7 sm:text-lg 3xl:text-2xl font-bold rounded-lg cursor-pointer block w-fit ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btnStyle)}`;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: regularButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            onClick: scrollButton ? scrollToTop : onCLick,
            className: buttonClassName,
            children: children
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: pdf ? "_blank" : "_self",
            rel: "noreferrer",
            className: buttonClassName,
            children: children
        })
    });
}


/***/ }),

/***/ 54531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ getUrl; },
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "U8": function() { return /* binding */ getKeyWordsForMetaTags; },
/* harmony export */   "Z5": function() { return /* binding */ getMetaTitleDescriptionForPage; },
/* harmony export */   "_7": function() { return /* binding */ getDescriptionForPostByID; },
/* harmony export */   "_H": function() { return /* binding */ getMainTitlesNavigationFromBody; },
/* harmony export */   "fH": function() { return /* binding */ getFinalLogosForLogoSLider; },
/* harmony export */   "fx": function() { return /* binding */ getDescriptionForHomePage; },
/* harmony export */   "nn": function() { return /* binding */ addStyleClassToIframe; },
/* harmony export */   "qp": function() { return /* binding */ getKeyWordsForPostByID; },
/* harmony export */   "yV": function() { return /* binding */ addStyleClassToTable; }
/* harmony export */ });
/* unused harmony export extractExcerptFromBody */
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75094);

const getUrl = (pathname = "")=>{
    return `${window.location.origin}${pathname}`;
};
const getMainTitlesNavigationFromBody = (html)=>{
    const regex = /<[^>]+ id="([^"]+)"[^>]*>([\s\S]+?)<\/[^>]+>/g;
    const result = [];
    let match;
    while(match = regex.exec(html)){
        const [, id, content] = match;
        const textNodes = content.match(/>([^<]+)/g);
        if (textNodes) {
            result.push(// eslint-disable-next-line no-unsafe-optional-chaining
            ...textNodes?.map((node)=>({
                    value: node.substring(1).trim(),
                    id
                })));
        } else {
            result.push({
                value: content.trim(),
                id
            });
        }
    }
    return result.filter((i)=>i.value?.length > 1).map((el)=>({
            title: /^\d/.test(el.value) ? el.value.replace(/^\d/, "").slice(1) : el.value,
            link: `#${el.id}`
        }));
};
const addStyleClassToTable = (body)=>{
    if (body) {
        // start tag replace with <div className="table-responsive" > <table
        const firstSectionStartTag = body?.split("<table")[0]; // first section dose not contain <table to replace
        const bodyAfterReplaceStartTag = body?.split("<table").slice(1).map((table)=>{
            return `<div class="table-responsive"> <table ${table}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </table> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</table>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</table>").slice(1).map((table)=>{
            return `</table></div>${table}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const addStyleClassToIframe = (body)=>{
    if (body) {
        // start tag replace with <div className="iframe-responsive" > <iframe
        const firstSectionStartTag = body?.split("<iframe")[0]; // first section dose not contain <iframe to replace
        const bodyAfterReplaceStartTag = body?.split("<iframe").slice(1).map((iframe)=>{
            return `<div class="iframe-responsive"> <iframe ${iframe}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </iframe> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</iframe>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</iframe>").slice(1).map((iframe)=>{
            return `</iframe></div>${iframe}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const getFormattedDate = (date)=>{
    const regex = /^[0-9]+$/; //check if the string contain only numeric characters(time stamp)
    return new Date(regex.test(date) ? +date : date).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};
const extractExcerptFromBody = (body, characters)=>{
    return body.replace(/<[^>]+>/g, "").substring(0, characters).trim();
};
const getDescriptionForPostByID = (post)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post.metatags[i]?.key === "description" && post.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.excerpt) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.excerpt, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    if (post?.body) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.body, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForPostByID = (post, domainInfo)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post?.metatags[i]?.key === "keywords" && post?.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.tags) {
        return post?.tags?.map((tag)=>tag?.name).join(",");
    }
    for(let i1 = 0; i1 < (domainInfo?.metatags.length ?? 0); i1++){
        if (domainInfo?.metatags[i1]?.key === "keywords" && domainInfo?.metatags[i1]?.value) {
            return domainInfo?.metatags[i1]?.value;
        }
    }
    return "";
};
const getDescriptionForHomePage = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "extra-meta-HomePage-meta-description" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    if (domain?.description) {
        return domain.description.replace(/<[^>]+>/g, "");
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForMetaTags = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "keywords" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    return "";
};
const getMetaTitleDescriptionForPage = (domain, keyPage)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        return {
            title: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-title`)?.value,
            description: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-description`)?.value
        };
    }
};
const getFinalLogosForLogoSLider = (featuredList, categorySlug)=>{
    const finalLogos = featuredList ? categorySlug ? featuredList[categorySlug] : featuredList["default"] : [];
    return finalLogos;
};


/***/ }),

/***/ 64080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WhyPartnerWithUs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32233);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76265);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12658);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81467);





function WhyPartnerWithUs({ partnerWitUSData  }) {
    const mainSectionDevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .Y)(mainSectionDevRef, {
        once: true
    });
    const firstEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .useAnimation */ ._)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isInView) {
            firstEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.section */ .E.section, {
        ref: mainSectionDevRef,
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bgStyle),
        variants: {
            visible: {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ],
                transition: {
                    duration: 1.5
                }
            }
        },
        animate: firstEl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: `font-bold 3xl:text-6xl lg:text-5xl text-3xl lg:leading-[54px] leading-9 ${partnerWitUSData.titleClassName ?? ""}`,
                children: partnerWitUSData.title
            }),
            partnerWitUSData.paragraphs.map((p, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: p.className === "default" ? "3xl:mt-6  mt-3 3xl:text-2xl  3xl:leading-10 lg:text-lg  3xl:max-w-[1040px] max-w-[740px]  font-light" : p.className,
                    children: p.text
                }, index)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:mt-9 mt-12 w-fit ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    href: "/partner-with-us",
                    children: partnerWitUSData.buttonText
                })
            })
        ]
    });
}


/***/ }),

/***/ 95301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Loader({ size , className  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `flex items-center ${className ?? ""}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "animate-loader-spin",
            style: {
                width: `${size}px`,
                height: `${size}px`
            },
            role: "progressbar",
            color: "white",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                className: "block",
                viewBox: "22 22 44 44",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    style: {
                        stroke: "currentcolor",
                        strokeDasharray: "80px,200px",
                        strokeDashoffset: 0
                    },
                    cx: "44",
                    cy: "44",
                    r: "20.2",
                    fill: "none",
                    strokeWidth: "3.6"
                })
            })
        })
    });
}


/***/ }),

/***/ 82651:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogEl":"style_blogEl___u_a8","imgContainer":"style_imgContainer__mCVg1"};

/***/ }),

/***/ 57772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btnStyle":"style_btnStyle___YUoh"};

/***/ }),

/***/ 12658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__n_Qd3"};

/***/ }),

/***/ 50259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pm": function() { return /* binding */ h; },
/* harmony export */   "xX": function() { return /* binding */ g; }
/* harmony export */ });
/* unused harmony exports GoogleReCaptcha, GoogleReCaptchaConsumer, GoogleReCaptchaContext, withGoogleReCaptcha */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* provided dependency */ var process = __webpack_require__(83454);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var s=function(){return s=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},s.apply(this,arguments)};function u(e,t,r,o){return new(r||(r=Promise))((function(n,a){function c(e){try{s(o.next(e))}catch(e){a(e)}}function i(e){try{s(o.throw(e))}catch(e){a(e)}}function s(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(c,i)}s((o=o.apply(e,t||[])).next())}))}function l(e,t){var r,o,n,a,c={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return a={next:i(0),throw:i(1),return:i(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function i(a){return function(i){return function(a){if(r)throw new TypeError("Generator is already executing.");for(;c;)try{if(r=1,o&&(n=2&a[0]?o.return:a[0]?o.throw||((n=o.return)&&n.call(o),0):o.next)&&!(n=n.call(o,a[1])).done)return n;switch(o=0,n&&(a=[2&a[0],n.value]),a[0]){case 0:case 1:n=a;break;case 4:return c.label++,{value:a[1],done:!1};case 5:c.label++,o=a[1],a=[0];continue;case 7:a=c.ops.pop(),c.trys.pop();continue;default:if(!(n=c.trys,(n=n.length>0&&n[n.length-1])||6!==a[0]&&2!==a[0])){c=0;continue}if(3===a[0]&&(!n||a[1]>n[0]&&a[1]<n[3])){c.label=a[1];break}if(6===a[0]&&c.label<n[1]){c.label=n[1],n=a;break}if(n&&c.label<n[2]){c.label=n[2],c.ops.push(a);break}n[2]&&c.ops.pop(),c.trys.pop();continue}a=t.call(e,c)}catch(e){a=[6,e],o=0}finally{r=n=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,i])}}}var f,p=function(e){var t;e?function(e){if(e)for(;e.lastChild;)e.lastChild.remove()}("string"==typeof e?document.getElementById(e):e):(t=document.querySelector(".grecaptcha-badge"))&&t.parentNode&&document.body.removeChild(t.parentNode)},d=function(e,t){p(t),window.___grecaptcha_cfg=void 0;var r=document.querySelector("#"+e);r&&r.remove(),function(){var e=document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');e&&e.remove()}()},y=function(e){var t=e.render,r=e.onLoadCallbackName,o=e.language,n=e.onLoad,a=e.useRecaptchaNet,c=e.useEnterprise,i=e.scriptProps,s=void 0===i?{}:i,u=s.nonce,l=void 0===u?"":u,f=s.defer,p=void 0!==f&&f,d=s.async,y=void 0!==d&&d,m=s.id,v=void 0===m?"":m,b=s.appendTo,h=v||"google-recaptcha-v3";if(function(e){return!!document.querySelector("#"+e)}(h))n();else{var g=function(e){return"https://www."+(e.useRecaptchaNet?"recaptcha.net":"google.com")+"/recaptcha/"+(e.useEnterprise?"enterprise.js":"api.js")}({useEnterprise:c,useRecaptchaNet:a}),S=document.createElement("script");S.id=h,S.src=g+"?render="+t+("explicit"===t?"&onload="+r:"")+(o?"&hl="+o:""),l&&(S.nonce=l),S.defer=!!p,S.async=!!y,S.onload=n,("body"===b?document.body:document.getElementsByTagName("head")[0]).appendChild(S)}},m=function(e){"undefined"!=typeof process&&!!process.env&&"production"!=="production"||console.warn(e)};!function(e){e.SCRIPT_NOT_AVAILABLE="Recaptcha script is not available"}(f||(f={}));var v=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({executeRecaptcha:function(){throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider")}}),b=v.Consumer;function h(t){var i=t.reCaptchaKey,u=t.useEnterprise,l=void 0!==u&&u,p=t.useRecaptchaNet,b=void 0!==p&&p,h=t.scriptProps,g=t.language,S=t.container,w=t.children,$=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),C=$[0],P=$[1],x=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(i),E=JSON.stringify(h),R=JSON.stringify(null==S?void 0:S.parameters);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((function(){if(i){var e=(null==h?void 0:h.id)||"google-recaptcha-v3",t=(null==h?void 0:h.onLoadCallbackName)||"onRecaptchaLoadCallback";window[t]=function(){var e=l?window.grecaptcha.enterprise:window.grecaptcha,t=s({badge:"inline",size:"invisible",sitekey:i},(null==S?void 0:S.parameters)||{});x.current=e.render(null==S?void 0:S.element,t)};return y({render:(null==S?void 0:S.element)?"explicit":i,onLoadCallbackName:t,useEnterprise:l,useRecaptchaNet:b,scriptProps:h,language:g,onLoad:function(){if(window&&window.grecaptcha){var e=l?window.grecaptcha.enterprise:window.grecaptcha;e.ready((function(){P(e)}))}else m("<GoogleRecaptchaProvider /> "+f.SCRIPT_NOT_AVAILABLE)},onError:function(){m("Error loading google recaptcha script")}}),function(){d(e,null==S?void 0:S.element)}}m("<GoogleReCaptchaProvider /> recaptcha key not provided")}),[l,b,E,R,g,i,null==S?void 0:S.element]);var M=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((function(e){if(!C||!C.execute)throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");return C.execute(x.current,{action:e})}),[C,x]),N=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)((function(){return{executeRecaptcha:C?M:void 0,container:null==S?void 0:S.element}}),[M,C,null==S?void 0:S.element]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(v.Provider,{value:N},w)}var g=function(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(v)};function S(t){var r=this,o=t.action,a=t.onVerify,c=t.refreshReCaptcha,i=g();n((function(){var e=i.executeRecaptcha;if(e){u(r,void 0,void 0,(function(){var t;return l(this,(function(r){switch(r.label){case 0:return[4,e(o)];case 1:return t=r.sent(),a?(a(t),[2]):(m("Please define an onVerify function"),[2])}}))}))}}),[o,a,c,i]);var s=i.container;return"string"==typeof s?e.createElement("div",{id:s}):null}function w(e,t){return e(t={exports:{}},t.exports),t.exports
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */}var $="function"==typeof Symbol&&Symbol.for,C=$?Symbol.for("react.element"):60103,P=$?Symbol.for("react.portal"):60106,x=$?Symbol.for("react.fragment"):60107,E=$?Symbol.for("react.strict_mode"):60108,R=$?Symbol.for("react.profiler"):60114,M=$?Symbol.for("react.provider"):60109,N=$?Symbol.for("react.context"):60110,O=$?Symbol.for("react.async_mode"):60111,_=$?Symbol.for("react.concurrent_mode"):60111,T=$?Symbol.for("react.forward_ref"):60112,j=$?Symbol.for("react.suspense"):60113,L=$?Symbol.for("react.suspense_list"):60120,k=$?Symbol.for("react.memo"):60115,F=$?Symbol.for("react.lazy"):60116,A=$?Symbol.for("react.block"):60121,V=$?Symbol.for("react.fundamental"):60117,z=$?Symbol.for("react.responder"):60118,G=$?Symbol.for("react.scope"):60119;function I(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case C:switch(e=e.type){case O:case _:case x:case R:case E:case j:return e;default:switch(e=e&&e.$$typeof){case N:case T:case F:case k:case M:return e;default:return t}}case P:return t}}}function D(e){return I(e)===_}var q={AsyncMode:O,ConcurrentMode:_,ContextConsumer:N,ContextProvider:M,Element:C,ForwardRef:T,Fragment:x,Lazy:F,Memo:k,Portal:P,Profiler:R,StrictMode:E,Suspense:j,isAsyncMode:function(e){return D(e)||I(e)===O},isConcurrentMode:D,isContextConsumer:function(e){return I(e)===N},isContextProvider:function(e){return I(e)===M},isElement:function(e){return"object"==typeof e&&null!==e&&e.$$typeof===C},isForwardRef:function(e){return I(e)===T},isFragment:function(e){return I(e)===x},isLazy:function(e){return I(e)===F},isMemo:function(e){return I(e)===k},isPortal:function(e){return I(e)===P},isProfiler:function(e){return I(e)===R},isStrictMode:function(e){return I(e)===E},isSuspense:function(e){return I(e)===j},isValidElementType:function(e){return"string"==typeof e||"function"==typeof e||e===x||e===_||e===R||e===E||e===j||e===L||"object"==typeof e&&null!==e&&(e.$$typeof===F||e.$$typeof===k||e.$$typeof===M||e.$$typeof===N||e.$$typeof===T||e.$$typeof===V||e.$$typeof===z||e.$$typeof===G||e.$$typeof===A)},typeOf:I},B=w((function(e,t){ false&&0})),J=(B.AsyncMode,B.ConcurrentMode,B.ContextConsumer,B.ContextProvider,B.Element,B.ForwardRef,B.Fragment,B.Lazy,B.Memo,B.Portal,B.Profiler,B.StrictMode,B.Suspense,B.isAsyncMode,B.isConcurrentMode,B.isContextConsumer,B.isContextProvider,B.isElement,B.isForwardRef,B.isFragment,B.isLazy,B.isMemo,B.isPortal,B.isProfiler,B.isStrictMode,B.isSuspense,B.isValidElementType,B.typeOf,w((function(e){ true?e.exports=q:0}))),K={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},U={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},H={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},Q={};function W(e){return J.isMemo(e)?H:Q[e.$$typeof]||K}Q[J.ForwardRef]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},Q[J.Memo]=H;var X=Object.defineProperty,Y=Object.getOwnPropertyNames,Z=Object.getOwnPropertySymbols,ee=Object.getOwnPropertyDescriptor,te=Object.getPrototypeOf,re=Object.prototype;var oe=function e(t,r,o){if("string"!=typeof r){if(re){var n=te(r);n&&n!==re&&e(t,n,o)}var a=Y(r);Z&&(a=a.concat(Z(r)));for(var c=W(t),i=W(r),s=0;s<a.length;++s){var u=a[s];if(!(U[u]||o&&o[u]||i&&i[u]||c&&c[u])){var l=ee(r,u);try{X(t,u,l)}catch(e){}}}}return t},ne=function(t){var r=function(r){return e.createElement(b,null,(function(o){return e.createElement(t,s({},r,{googleReCaptchaProps:o}))}))};return r.displayName="withGoogleReCaptcha("+(t.displayName||t.name||"Component")+")",oe(r,t),r};
//# sourceMappingURL=react-google-recaptcha-v3.esm.js.map


/***/ }),

/***/ 32233:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// UNUSED EXPORTS: useAnimationControls

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/errors.mjs
var errors = __webpack_require__(45487);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/setters.mjs + 1 modules
var setters = __webpack_require__(14330);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/interfaces/visual-element.mjs + 2 modules
var visual_element = __webpack_require__(76432);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/hooks/animation-controls.mjs




function stopAnimation(visualElement) {
    visualElement.values.forEach((value) => value.stop());
}
/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    let hasMounted = false;
    /**
     * A collection of linked component animation controls.
     */
    const subscribers = new Set();
    const controls = {
        subscribe(visualElement) {
            subscribers.add(visualElement);
            return () => void subscribers.delete(visualElement);
        },
        start(definition, transitionOverride) {
            (0,errors/* invariant */.k)(hasMounted, "controls.start() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            const animations = [];
            subscribers.forEach((visualElement) => {
                animations.push((0,visual_element/* animateVisualElement */.d)(visualElement, definition, {
                    transitionOverride,
                }));
            });
            return Promise.all(animations);
        },
        set(definition) {
            (0,errors/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach((visualElement) => {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop() {
            subscribers.forEach((visualElement) => {
                stopAnimation(visualElement);
            });
        },
        mount() {
            hasMounted = true;
            return () => {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(96681);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(58868);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/hooks/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimationControls() {
    const controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(controls.mount, []);
    return controls;
}
const useAnimation = useAnimationControls;




/***/ }),

/***/ 37301:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ resolveElements; }
/* harmony export */ });
/* harmony import */ var _utils_errors_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45487);


function resolveElements(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0,_utils_errors_mjs__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .k)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = root.querySelectorAll(elements));
            elements = selectorCache[elements];
        }
        else {
            elements = root.querySelectorAll(elements);
        }
    }
    else if (elements instanceof Element) {
        elements = [elements];
    }
    /**
     * Return an empty array
     */
    return Array.from(elements || []);
}




/***/ }),

/***/ 16893:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useInView; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/resolve-element.mjs
var resolve_element = __webpack_require__(37301);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/viewport/index.mjs


const thresholds = {
    some: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "some" } = {}) {
    const elements = (0,resolve_element/* resolveElements */.I)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (typeof newOnEnd === "function") {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs



function useInView(ref, { root, margin, amount, once = false } = {}) {
    const [isInView, setInView] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount,
        };
        return inView(ref.current, onEnter, options);
    }, [root, ref, margin, once, amount]);
    return isInView;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [11943,81711,49774,92888,40179], function() { return __webpack_exec__(24979); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);